export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const extractImageLabel = (fileUrlOrName) => {
  if (!fileUrlOrName) return null;
  
  const fileName = fileUrlOrName.toString().split('/').pop(); // Extract from URL if needed
  const match = fileName.match(/filename-(.+)\.(jpg|jpeg|png|webp|gif|bmp)$/i);

  if (!match) return null;

  const rawName = match[1];
  const readableName = rawName.replace(/-/g, ' ');

  return readableName;
}

export const extractImageLabelUpdate = (fileUrlOrName) => {
  if (!fileUrlOrName) return "blog image"; // Default alt text
  const fileName = fileUrlOrName.toString().split('/').pop().split('?')[0];
  const match = fileName.match(/^(.*?)\.(jpg|jpeg|png|webp|gif|bmp)$/i);
  if (!match || !match[1]) {
    return fileName.substring(0, fileName.lastIndexOf('.'))
                   .replace(/[-_]/g, ' ')
                   .replace(/%20/g, ' ') || "blog image";
  }
  const rawName = match[1];
  return rawName.replace(/[-_]/g, ' ').replace(/%20/g, ' ') || "blog image";
}

export const LogoutModal = ({ show, onConfirm }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h5 className="mb-12 fw-semibold">Profile Updated</h5>
        <p className="mb-16">You need to log in again to continue.</p>
        <button className="btn btn-bg btn-block" onClick={onConfirm}>
          Okay, Log Me Out
        </button>
      </div>
    </div>
  );
};



export async function uploadImageToServer(file) {
  const form = new FormData();
  form.append("image", file);

  const res = await fetch(`${process.env.REACT_APP_BASE_URL}/upload`, {
    method: "POST",
    body: form,
  });

  if (!res.ok) throw new Error("Image upload failed");

  const data = await res.json();
  return {imageUrl: data.imageUrl, originalFilename: data.originalFilename};
}